export const TRAVEL_LOCATION = `/travel/orders`;

export const DATA_TRAVEL_LOCATION = `/data/travels/details`;
